<header class="border-bottom border-gray-400" [ngClass]="theme === 'ade' ? 'bg-primary' : 'bg-white'" id="public-header">
	<div class="w-100 ps-4 pe-3">
		<div style="height: 3.8rem" class="d-flex justify-content-between align-items-center">
			<div class="d-flex align-items-center gap-3">
				<!--Orca Logo-->
				@if (IsNullish(integrationSettings) || (!IsNullish(integrationSettings) && !integrationSettings.neutralDesign)) {
					<div (click)="showWarningIfPreview()">
						<a [routerLink]="['/']" [target]="target" [class.link-disabled]="disableNavigate" (click)="signetClick.emit()">
							<img src="assets/orca/header/signet.svg" loading="eager" decoding="async" alt="Orca logo" class="orca-logo" />
						</a>
					</div>
				}
				<!--Burgermenü-->
				@if (presentationNavigation) {
					<div class="d-flex header-presentation-navigation-gap px-4 me-3">
						<a class="text-larger text-dark no-break" href="/#about-us" rel="noreferrer">
							{{ 'header.about-us' | translate }}
						</a>
						<a class="text-larger text-dark no-break" href="/#know-how" rel="noreferrer">
							{{ 'header.know-how' | translate }}
						</a>
						<a class="text-larger text-dark no-break" [href]="trainingLink" rel="noreferrer" target="_blank">
							{{ 'header.further-training' | translate }}
							<img src="/assets/orca/header/powerdby_wlb.svg" alt="poweredby-wlb" loading="eager" decoding="async" />
						</a>
					</div>
				} @else {
					<img
						src="/assets/orca/header/burger-menu.svg"
						class="burgermenu cursor-pointer"
						alt="burgermenu-navigation"
						loading="eager"
						decoding="async"
						(mouseup)="headerBurgerMenu.triggerMenu()"
						(mousedown)="headerBurgerMenu.triggerMenuMouseDown()" />
				}
				@if (!IsNullish(integrationSettings) && integrationSettings.neutralDesign) {
					<div>
						<span>
							{{ 'header.integration-header' | translate }}
						</span>
						<a [ngClass]="disableNavigate ? 'link-disabled' : 'app-link-dark'" [routerLink]="['/']" [target]="target">
							AUSSCHREIBEN.DE
						</a>
					</div>
				}
			</div>
			@if (canSearchbarBeDisplayed) {
				<div class="headersearchbar-container w-100 mx-1" [ngClass]="{ fadeout: !canSearchbarBeDisplayed }">
					<app-searchbar
						id=" headersearchbar"
						[hasborder]="theme === 'neutral'"
						(searchCommit)="searchCommit.emit()"
						(emptySearch)="emptySearch.emit()"
						[useOptionalCategoryGroupFilter]="useOptionalCategoryGroupFilter"
						[searchbarExistsInHeader]="true"
						[applySearchTerm]="applySearchTerm"
						[searchbarIsVisible]="searchbarIsVisible"
						[disableFocus]="noFocusForSearchbar"
						(initSearchbar)="initSearchbar.emit()">
					</app-searchbar>
				</div>
			}
			@if (title) {
				<div class="d-flex align-items-center title center">{{ title }}</div>
			}

			<div class="me-3 d-flex gap-4 justify-content-end align-items-center">
				<!--Infoletter-->
				@if (showInfoletter) {
					<app-infoletter-header></app-infoletter-header>
				}

				@if (catalogIntegrationType === catalogIntegrationTypeEnum.CatalogItemViewer) {
					<div>
						<div class="d-flex my-2">
							<div class="mx-2 d-flex align-items-center">
								<div class="text-end app-link-dark" (click)="toggleAccount()">
									{{ accountHandleView }}
								</div>
							</div>
							<div class="d-flex align-items-center">
								<app-fullscreen-header />
							</div>
						</div>
					</div>
				} @else {
					<app-fullscreen-header />
					<!--Merkliste wird in der SEOkritischen Mobileansicht beim Katalog immer angezeit. Deshalb KEINE deferabfrage-->
					@if (hasWatchlist) {
						<!--Merkliste-->
						<app-watchlist-header-navigation
							[showInternalWatchlist]="showInternalWatchlist"
							[showWatchlistTitle]="showWatchlistTitle"
							[isMobile]="false"
							[currentLanguage]="currentLanguage"
							[theme]="theme">
						</app-watchlist-header-navigation>
					}
					@if (showLanguage) {
						<div class="language">
							@defer {
								<!--Spracheinstellung-->
								<app-language (languageChange)="languageChange.emit($event); currentLanguage = $event" [isMobile]="false" />
							}
						</div>
					}
					<!--Hilfe-->
					<app-help-public></app-help-public>
					<!--Anmeldung-->
					<app-user-menu-context [catalogKey]="catalogKey" target="_blank" rel="noopener"> </app-user-menu-context>
				}
			</div>
		</div>
	</div>
</header>

<app-header-burger-menu
	[isPreview]="isPreview"
	[canNavigateToStartingPage]="canNavigateToStartingPage"
	[isInIntegrationMode]="isInIntegrationMode"
	#headerBurgerMenu
	class="h-100">
</app-header-burger-menu>
